import { apiRequest } from './api';
import { AdvSet, AdvSetWithAdvs, AdvSetRequest, AdvSetAdvRequest } from '../types/adv';

export const advSetService = {
  // Get all advertisement sets
  getAllAdvSets: async (): Promise<AdvSet[]> => {
    return await apiRequest<AdvSet[]>('/adv_sets');
  },

  // Get advertisement set by ID with associated advertisements
  getAdvSetById: async (id: number): Promise<AdvSetWithAdvs> => {
    return await apiRequest<AdvSetWithAdvs>(`/adv_sets/${id}`);
  },

  // Create new advertisement set
  createAdvSet: async (set: AdvSetRequest): Promise<AdvSet> => {
    return await apiRequest<AdvSet>('/adv_sets/create', {
      method: 'POST',
      body: JSON.stringify(set)
    });
  },

  // Update existing advertisement set
  updateAdvSet: async (id: number, set: AdvSetRequest): Promise<AdvSet> => {
    return await apiRequest<AdvSet>(`/adv_sets/${id}`, {
      method: 'PUT',
      body: JSON.stringify(set)
    });
  },

  // Delete advertisement set
  deleteAdvSet: async (id: number): Promise<void> => {
    return await apiRequest<void>(`/adv_sets/${id}`, {
      method: 'DELETE'
    });
  },

  // Add advertisement to set
  addAdvToSet: async (setId: number, advId: number): Promise<void> => {
    const request: AdvSetAdvRequest = { adv_id: advId };
    return await apiRequest<void>(`/adv_sets/${setId}/advs`, {
      method: 'POST',
      body: JSON.stringify(request)
    });
  },

  // Remove advertisement from set
  removeAdvFromSet: async (setId: number, advId: number): Promise<void> => {
    return await apiRequest<void>(`/adv_sets/${setId}/advs/${advId}`, {
      method: 'DELETE'
    });
  }
}; 